
  import { defineComponent, PropType } from 'vue';

  export default defineComponent({
    name: 'adfox-banner',

    props: {
      containerId: {
        type: String,
        required: true,
      },
      ownerId: {
        type: String,
        required: true,
      },
      p1: {
        type: String,
        required: true,
      },
      p2: {
        type: String,
        required: true,
      },
      lazyLoad: {
        type: Object,
        default: () => ({
          fetchMargin: 100,
          mobileScaling: 2,
        }),
      },
      layouts: {
        type: Array as PropType<string[]>,
        default: () => [],
      },
      params: {
        type: Object as PropType<{
          tabletWidth: number;
          phoneWidth: number;
          isAutoReloads: boolean;
        }>,
        default: () => ({
          tabletWidth: 1000,
          phoneWidth: 640,
          isAutoReloads: false,
        }),
      },
    },

    mounted() {
      (window as any).yaContextCb &&
        (window as any).yaContextCb.push(() => {
          (window as any).Ya.adfoxCode.createAdaptive(
            {
              ownerId: this.ownerId,
              containerId: this.containerId,
              params: {
                p1: this.p1,
                p2: this.p2,
              },
            },
            this.layouts,
            this.params,
          );
        });
    },
  });
